import type { Countries, Country, CountryApi, CountryFilters } from '../../models';

export const normalizeCountry = (country: CountryApi): Country => ({
  id: country.countryCode,
  label: country.countryName,
});

export const normalizeCountries = (countries: CountryApi[]): Countries => {
  const list = countries.map(normalizeCountry).sort((a, b) => a.label.localeCompare(b.label));

  return {
    list,
    map: list.reduce(
      (acc, country) => {
        acc[String(country.id)] = country;
        return acc;
      },
      {} as Countries['map'],
    ),
  };
};

export const filterCountries = (countries: Countries, filters: Partial<CountryFilters> = {}): Countries => {
  let { list } = countries;

  const searchQuery = filters.search?.countryName?.trim()?.toLowerCase();
  if (searchQuery) {
    list = list.filter((country) => {
      const name = country.label.toLowerCase();
      const code = String(country.id).toLowerCase();
      return name.includes(searchQuery) || code.includes(searchQuery);
    });
  }

  const countryCodeSearch = filters.search?.countryCode?.trim();
  if (countryCodeSearch) {
    const codes = countryCodeSearch.split(',').map((code) => code.trim().toLowerCase());
    list = list.filter((country) => codes.includes(String(country.id).toLowerCase()));
  }

  return {
    list,
    map: list.reduce(
      (acc, country) => {
        acc[String(country.id)] = country;
        return acc;
      },
      {} as Countries['map'],
    ),
  };
};
